import React, { useState } from "react";
import { Container, Modal, Button } from "react-bootstrap";
import { news1Img } from "../assets/images";
import Http from "../helper/Http";

const NewsTicker = ({ news, imageUrl }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedNews, setSelectedNews] = useState(null);
  const [loadingModal, setLoadingModal] = useState(false);

  const handleLearnMore = async (e, item) => {
    e.preventDefault();
    if (item.news_url) {
      window.open(item.news_url, "_blank");
    } else if (item.news_content || item._id) {
      if (item._id) {
        setLoadingModal(true);
        setShowModal(true);
        setSelectedNews({ ...item, news_content: item.news_content || "Loading..." });
        
        try {
          let path = `admin/getNewsDetail/${item._id}`;
          const res = await Http("GET", path);
          if (res && res.status === 200) {
            const resJson = await res.json();
            if (resJson.status && resJson.result) {
              setSelectedNews(resJson.result);
            }
          }
        } catch (error) {
          console.error("Error fetching news detail:", error);
        } finally {
          setLoadingModal(false);
        }
      } else if (item.news_content) {
        setSelectedNews(item);
        setShowModal(true);
      }
    }
  };

  if (!news || news.length === 0) {
    return null;
  }

  // Double the news list for a seamless infinite scroll effect
  const newsList = [...news, ...news];

  return (
    <section className="news_ticker_section">
      <Container>
        <div className="news_ticker_wrapper">
          <div className="news_ticker_label">Latest News</div>
          <div className="news_ticker_slider_css">
            <div className="news_ticker_track">
              {newsList.map((item, index) => (
                <div key={index} className="news_item_container">
                  <div className="news_ticker_item">
                    <img
                      src={item.image ? `${imageUrl}/${item.image}` : news1Img}
                      alt={item.title || "news"}
                      className="news_ticker_icon"
                    />
                    <div className="news_ticker_content">
                      <p className="news_ticker_text">{item.title || item.text}</p>
                      {item.description && (
                        <p className="news_ticker_desc">
                          {item.description}
                        </p>
                      )}
                      <a 
                        href={item.news_url || "#"} 
                        className="news_ticker_link"
                        onClick={(e) => handleLearnMore(e, item)}
                      >
                        Learn More <i className="fas fa-chevron-right ml-1"></i>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title className="font-weight-bold">{selectedNews?.title || "News Detail"}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          {loadingModal ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="news-content-body">
              {selectedNews?.image && (
                <img 
                  src={`${imageUrl}/${selectedNews.image}`} 
                  alt={selectedNews.title} 
                  className="img-fluid mb-4 rounded shadow-sm" 
                  style={{ width: '100%', maxHeight: '400px', objectFit: 'cover' }}
                />
              )}
              
              {selectedNews?.description && (
                <div className="news-description mb-4">
                  <p className="mb-0">
                    {selectedNews.description}
                  </p>
                </div>
              )}

              {selectedNews?.news_content && (
                <div 
                  className="news-full-content mt-3"
                  dangerouslySetInnerHTML={{ __html: selectedNews.news_content }} 
                />
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
};

export default NewsTicker;
